module.exports = __webpack_public_path__ + "img/icon_material_kctg.16834a1d.webp";